import React from "react";
import { Link, useLocation, matchPath } from "react-router-dom";
import { FiSearch, FiBell, FiSettings, FiChevronRight } from "react-icons/fi";

const ROUTE_BREADCRUMBS = {
  "/overview": { category: "Main Navigation", title: "Overview" },
  "/academic": { category: "Academic", title: "Console" },
  "/registrar": { category: "Admission", title: "New Student Registration" },
  "/classroom_manager": { category: "Classroom", title: "Observation" },
  "/employees": { category: "Employee", title: "Console" },
  "/leave": { category: "Employee", title: "Leave Record" },
  "/attendance": { category: "Employee", title: "Worship Attendance" },
  "/attendance/reports": { category: "Employee", title: "Attendance Report" },
  "/inventory": { category: "Main Navigation", title: "Inventory" },
  "/library": { category: "Main Navigation", title: "Library" },
  "/students": { category: "Student", title: "List" },
  "/students/uniform": { category: "Student", title: "Uniform Infraction" },
  "/students/:id": { category: "Student", title: "Detail" },
  "/teacher/student/list": { category: "Student", title: "List" },
  "/teacher/student/:id": { category: "Student", title: "Detail" },
  "/users": { category: "Security & Permission", title: "User Account" },
  "/account/locked": { category: "Security & Permission", title: "User Locked" },
  "/support/feedback": { category: "Support", title: "Feedback" },
  "/support/help": { category: "Support", title: "Help & Support" },
  "/configuration": { category: "System", title: "Configuration" },
  "/report_manager": { category: "Report", title: "Report Manager" },
  "/my/profile": { category: "User Account", title: "My Profile" },
};

export default function Header({
  searchQuery,
  setSearchQuery,
  notifOpen,
  setNotifOpen,
  notificationDropdownRef,
}) {
  const location = useLocation();

  // Dynamic route resolution using React Router's matchPath
  const getRouteConfig = () => {
    // 1. First attempt direct match for exact routes
    if (ROUTE_BREADCRUMBS[location.pathname]) {
      return ROUTE_BREADCRUMBS[location.pathname];
    }

    // 2. Fall back to checking parameter routes (like /students/:id)
    const matchingPattern = Object.keys(ROUTE_BREADCRUMBS).find((pattern) =>
      matchPath({ path: pattern, end: true }, location.pathname)
    );

    return matchingPattern
      ? ROUTE_BREADCRUMBS[matchingPattern]
      : { category: "Main Navigation", title: "Dashboard" };
  };

  const currentRoute = getRouteConfig();

  return (
    <header className="h-14 bg-white border-b border-zinc-200/80 px-6 flex items-center justify-between sticky top-0 z-30 transition-all">
      
      {/* Dynamic Breadcrumb Navigation */}
      <div className="flex items-center gap-2 text-xs font-medium text-zinc-500">
        {location.pathname !== "/overview" && (
          <>
            <span className="hover:text-zinc-900 cursor-default transition-colors">
              {currentRoute.category}
            </span>
            <FiChevronRight className="w-3.5 h-3.5 text-zinc-400 shrink-0" />
            <span className="text-zinc-900 font-semibold">
              {currentRoute.title}
            </span>
          </>
        )}
      </div>

      {/* Right Side Controls */}
      <div className="flex items-center gap-3">
        <div className="relative" ref={notificationDropdownRef}>
          <button
            onClick={() => setNotifOpen(!notifOpen)}
            className="relative p-1.5 rounded-lg text-zinc-500 hover:text-zinc-900 hover:bg-zinc-100 transition-colors focus:outline-none"
            title="Notifications"
          >
            <FiBell className="w-4 h-4" />
            <span className="absolute top-1.5 right-1.5 w-1.5 h-1.5 bg-emerald-500 rounded-full animate-ping" />
            <span className="absolute top-1.5 right-1.5 w-1.5 h-1.5 bg-emerald-500 rounded-full" />
          </button>

          <div
            className={`absolute right-0 mt-2 w-72 bg-white border border-zinc-200 rounded-xl shadow-lg py-1.5 z-50 transform origin-top-right transition-all duration-150 ease-out ${
              notifOpen
                ? "opacity-100 scale-100 translate-y-0"
                : "opacity-0 scale-95 -translate-y-2 pointer-events-none"
            }`}
          >
            <div className="px-3.5 py-2 border-b border-zinc-100 flex items-center justify-between">
              <p className="text-xs font-semibold text-zinc-900">Notifications</p>
              <span className="text-[10px] font-semibold text-emerald-700 bg-emerald-50 border border-emerald-200 px-1.5 py-0.5 rounded-md">
                1 New
              </span>
            </div>
            
            <div className="p-1 max-h-64 overflow-y-auto">
              <div className="p-2.5 text-[11px] text-zinc-600 rounded-lg hover:bg-zinc-50 transition-colors cursor-pointer">
                <span className="font-semibold text-zinc-900 block mb-0.5">System Update</span>
                Permissions structures have updated successfully.
              </div>
            </div>
          </div>
        </div>

        <button
          className="p-1.5 rounded-lg text-zinc-500 hover:text-zinc-900 hover:bg-zinc-100 transition-colors"
          title="Settings"
        >
          <FiSettings className="w-4 h-4" />
        </button>
      </div>
    </header>
  );
}